import { useEffect, useState } from 'react';
import { Header } from '../../components/Header';
import { Sidebar } from '../../components/Sidebar';
import { Main } from '../../components/Main';
import { Form, Button, Col, Row } from 'react-bootstrap';
import { FormGroup } from '../../components/FormGroup';
import { Label } from '../../components/Label';
import AlertMessage from '../../components/Alert';
import api from '../../services/api';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { Autocomplete, TextField } from '@mui/material';

export function CuponsCadastrar() {
    const [nome, setNome] = useState("");
    const [codigoCupom, setCodigoCupom] = useState('');
    const [porcentagem, setPorcentagem]: any = useState(null);
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [produtos, setProdutos] = useState([])
    const [produtosSelecionados, setProdutosSelecionados]: any[] = useState([]);
    const navigate = useNavigate();

    const generateCupomCode = (nome: string, porcentagem: number) => {
        let nomePart = nome.toUpperCase().replace(/\s+/g, '');
        const extractedNumber = nomePart.match(/\d+/);
        let finalNumber: string;
        if (extractedNumber) {
            const extractedPorcentagem = parseInt(extractedNumber[0], 10);
            finalNumber = (extractedPorcentagem === porcentagem) ? extractedNumber[0] : porcentagem.toString().padStart(2, '0');
            nomePart = nomePart.replace(/\d+/g, '');
        } else {
            finalNumber = porcentagem.toString().padStart(2, '0');
        }
        return `${nomePart}${finalNumber}`;
    }

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await api.get('produtos')
                setProdutos(response.data)
                console.log(response.data)
            } catch (error) {
                console.error(error)
                setAlert({ message: 'Ocorreu um erro ao buscar os produtos!', variant: 'danger', show: true });
            }
        }
        fetchProducts()
    }, []);


    const handleSubmit = async (event: any) => {
        event.preventDefault();
        let isValid = true;
        if (!nome) {
            setAlert({ message: 'Por favor, preencha o campo nome!', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (/[À-ú]/.test(nome)) {
            setAlert({ message: 'O nome do cupom não pode conter acentos!', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (!porcentagem) {
            setAlert({ message: 'Por favor, preencha o campo de porcentagem de desconto!', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (produtosSelecionados.length == 0) {
            setAlert({ message: 'Por favor, selecione o produto em que o cupom será aplicado!', variant: 'danger', show: true });
            isValid = false;
            return
        }

        if (isValid) {
            const codigo = generateCupomCode(nome, porcentagem);
            try {
                const data = {
                    nome,
                    desconto: porcentagem,
                    codigo: codigo,
                    desativado: false,
                    produtos: produtosSelecionados
                }
                const response = await api.post('salvar-cupom', data);
                if (response.data.message) {
                    setAlert({ show: true, message: response.data.message, variant: 'danger' });
                } else if (response.status.toString().startsWith('20')) {
                    setCodigoCupom(codigo);
                    setAlert({ show: true, message: 'Cupom salvo com sucesso!', variant: 'success' });
                    setTimeout(() => navigate('/cupons'), 1000);
                }
            } catch (error) {
                console.error('Erro ao enviar dados do formulário:', error);
                setAlert({ show: true, message: 'Erro ao salvar o cupom.', variant: 'danger' });
            }
        }
    };

    return (
        <div>
            <Sidebar />
            <Header route='../../' />
            <Main>
                <Form onSubmit={handleSubmit}>
                    <h3>Informações Gerais</h3>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Nome' htmlFor="nome" />
                                <input
                                    type="text"
                                    id="nome"
                                    placeholder="Digite o Nome do Cupom"
                                    value={nome}
                                    onChange={(e) => {
                                        setNome(e.target.value);
                                    }}
                                    style={{ width: '100%' }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <FormGroup>
                                <Label title='Desconto' htmlFor="descricao" />
                                <input
                                    id="descricao"
                                    type='number'
                                    placeholder="Digite a porcentagem de desconto"
                                    value={porcentagem}
                                    onChange={(e) => setPorcentagem(e.target.value)}
                                    style={{ width: '100%' }} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={6} xl={6}>
                            <Form.Group controlId="formFuncao">
                                <Label title='Produtos' htmlFor="descricao" />
                                <Autocomplete
                                    multiple
                                    options={[{ id: 'todos', nome: 'TODOS' }, ...produtos]} 
                                    getOptionLabel={(option) => option ? option.nome : ""}
                                    value={produtosSelecionados}
                                    onChange={(_, newValue) => {
                                        if (newValue.some((option) => option.id === 'todos')) {
                                            if (!produtosSelecionados.some((item: any) => item.id === 'todos')) {
                                                setProdutosSelecionados([...produtos]);
                                            } else {
                                                setProdutosSelecionados([]);
                                            }
                                        } else {
                                            setProdutosSelecionados(newValue);
                                        }
                                    }}
                                    id="autocomplete-produtos"
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            placeholder={
                                                produtosSelecionados.length === 0
                                                    ? "Selecione os produtos que deseja aplicar o cupom"
                                                    : ""
                                            }
                                            size="small"
                                            style={{
                                                width: '100%',
                                                padding: '0.4rem',
                                                fontSize: '0.875rem',
                                                backgroundColor: 'white',
                                                borderRadius: '4px'
                                            }}
                                        />
                                    )}
                                    style={{
                                        width: '100%',
                                        fontSize: '0.875rem'
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <div style={{ marginTop: '10px' }}>
                                    <p>A Data de Expiração do cupom será de 24 horas após a criação.</p>
                                </div>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Button className="btn-main mt-4" type="submit">Inserir Cupom</Button>
                        </Col>
                    </Row>
                </Form>
            </Main>
            <AlertMessage
                show={alert.show}
                message={alert.message}
                variant={alert.variant}
                onClose={() => setAlert({ ...alert, show: false })}
            />
        </div>
    );
}
